import { render, staticRenderFns } from "./PortalCommonTable.vue?vue&type=template&id=d0fba376&scoped=true"
import script from "./PortalCommonTable.vue?vue&type=script&lang=js"
export * from "./PortalCommonTable.vue?vue&type=script&lang=js"
import style0 from "./PortalCommonTable.vue?vue&type=style&index=0&id=d0fba376&prod&lang=scss"
import style1 from "./PortalCommonTable.vue?vue&type=style&index=1&id=d0fba376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fba376",
  null
  
)

export default component.exports